/*! http://dev.housetrip.com/2014/09/15/decoupling-javascript-apps-using-pub-sub-pattern/ */

export default {
  topics: {},

  subscribe: function (topic, listener) {
    // Create topic if not yet created
    if (!this.topics[topic]) {
      this.topics[topic] = []
    }

    // Add topic listener
    this.topics[topic].push(listener)
  },

  publish: function (topic, data) {
    // Return if the topic doesn't exist
    // or if there are no listeners
    if (!this.topics[topic] || this.topics[topic].length < 1) {
      return
    }

    // Send event to all listeners
    this.topics[topic].forEach(listener => {
      listener(data || {})
    })
  }
}
